<med-label
  [label]="label"
  [name]="name"
  [disabled]="disabled"
  [required]="required"
  [labelClass]="labelClass"
>
  <div
    class="field__row"
    [ngClass]="{ field__container: hasErrorPadding }"
  >
    <input
      class="field"
      [id]="name"
      [attr.min]="min"
      [attr.max]="max"
      [name]="name"
      [type]="type"
      [attr.role]="role"
      [disabled]="disabled"
      [required]="required"
      [medFormatNubmer]="formatNumber"
      [medFormatNubmerPrecision]="precision"
      [placeholder]="placeholder"
      [ngClass]="classList"
      [(ngModel)]="value"
      (blur)="onBlur.emit($event)"
      (focus)="emitFocus($event)"
      (input)="onInput.emit($any($event).target.value)"
    />

    <ng-content></ng-content>
  </div>

  <div
    *ngIf="invalid"
    [ngClass]="{ up: hasErrorPadding }"
    class="field__error-message"
  >
    {{ errorMessage }}
  </div>
</med-label>
